<template>
    <div>
        <IMMForm
            formTitle="Cereri"
            labelName="Referitoare la proiect"
            inputType="text"
            textToCopy="Copiază în clipboard"
            readonly
            btn="Adauga"
            @openModal="modalShow = true"
        >
        </IMMForm>
        <IMMPopupDepunere
            :depunereModal="modalShow"
            popupTitle="Adauga cerere"
            inputType="text"
            labelName="Titlu *"
            labelName2="Apel *"
            labelName3="Tip cerere *"
            @hideDepPopup="modalShow = false"
        >

        </IMMPopupDepunere>
    </div>
</template>

<script>
    import IMMForm from '@/pages/Aplicatii/M3/M3Sketch/components/granturi-imm/IMMForm'
    import IMMPopupDepunere from '@/pages/Aplicatii/M3/M3Sketch/components/granturi-imm/IMMPopupDepunere'

    export default {
        components: {
            IMMForm,
            IMMPopupDepunere
        },
        data() {
            return {
                modalShow: false,
            }
        },
        computed: {
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        mounted() {

        },
        methods: {
        }
    }
</script>

<style scoped>
.modal-body {
    padding: 0!important;
}
</style>
